// jobRolesService.js

import apiClient from "./apiClient";

const JOB_ROLES_PATH = "/api/v3/jobRoles";
const TEAMS_PATH = "/api/v3/teams";
const PEOPLE_PATH = "/api/v3/people";

export const getAllJobRolesApi = async (data) => {
  const response = await apiClient.post(
    `${JOB_ROLES_PATH}/getAllJobRoles`,
    data,
  );
  return response.data;
};

export const getJobRolesDropDownApi = async () => {
  const response = await apiClient.get(
    `${JOB_ROLES_PATH}/getAllJobRolesForDropdown`,
  );
  return response.data;
};

export const createJobRoleApi = async (data) => {
  const response = await apiClient.post(
    `${JOB_ROLES_PATH}/createJobRole`,
    data,
  );
  return response.data;
};

export const aiJobDescriptionGenerationApi = async (data) => {
  const response = await apiClient.post(
    `${JOB_ROLES_PATH}/aiJobDescriptionGeneration`,
    data,
  );
  return response.data;
};

export const editJobRoleApi = async (data) => {
  const response = await apiClient.post(`${JOB_ROLES_PATH}/editJobRole`, data);
  return response.data;
};

export const createTeamApi = async (data) => {
  const response = await apiClient.post(`${TEAMS_PATH}/createTeam`, data);
  return response.data;
};

export const getJobRoleById = async (data) => {
  const response = await apiClient.post(
    `${JOB_ROLES_PATH}/getJobRoleById`,
    data,
  );
  return response.data;
};

export const deleteJobRole = async (data) => {
  const response = await apiClient.post(
    `${JOB_ROLES_PATH}/deleteJobRole`,
    data,
  );
  return response.data;
};

export const getAllPeopleApi = async (data = {}) => {
  const response = await apiClient.post(`${PEOPLE_PATH}/getAllPeople`, data);
  return response.data;
};

export const getPeopleSkillValuesApi = async (data) => {
  const response = await apiClient.post(
    `${JOB_ROLES_PATH}/getPeopleSkillValues`,
    data,
  );
  return response.data;
};

export const shareJobRolesWithPartnersApi = async (data) => {
  const response = await apiClient.post(
    `${JOB_ROLES_PATH}/shareJobRolesWithPartners`,
    data,
  );
  return response.data;
};
